import React from 'react';
import { useTranslation } from 'react-i18next';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';

export function CourseClassroomTabsList({ abilities }) {
  const { t } = useTranslation();

  const tabDefinitions = [
    {
      value: 'courseClassroomFiles',
      label: abilities?.['cursos-materiais'] ? 'Materiais e fórum' : 'Fórum',
      abilityKey: null
    },
    {
      value: 'courseClassroomQuestionBooks',
      label: t('lms.toggleQuestionBooks'),
      abilityKey: null
    },
    {
      value: 'courseClassroomActivities',
      label: t('lms.toggleActivity'),
      abilityKey: 'cursos-ativ-complementar'
    }
  ];

  return (
    <TabsList className="mb-4">
      {tabDefinitions
        .filter(tab => !tab.abilityKey || abilities?.[tab.abilityKey])
        .map(tab => (
          <TabsTrigger
            key={tab.value}
            value={tab.value}
          >
            {tab.label}
          </TabsTrigger>
        ))}
    </TabsList>
  );
}
